import { UserPermissions, type User } from '@models/user';

export const canUserEdit = (user: User | null): boolean => {
  if (!user) return false;

  return user.permissions.some((permission) => permission.code === 'users.update');
};

export const isUserAdmin = (user: User | null): boolean => {
  if (!user) return false;
  if (user.permissions.filter((permission) => permission.code === '*').length > 0) return true;

  return user.roles.includes('Admin');
};

export const canUserRead = (user: User): boolean => {
  if (!user) return false;

  return user.permissions.some((permission) => permission.code === UserPermissions.VIEW_USERS);
};

export const userHasPermission = (user: User, requiredPermission: string) => {
  const isAdmin = isUserAdmin(user);
  if (isAdmin) return true;

  return user.permissions.some((permission) => permission.code === requiredPermission);
};

export const isViewOnlyPermission = (user: User | null): boolean => {
  if (!user) return false;
  if (isUserAdmin(user)) return false;

  return (
    user.permissions.length > 0 &&
    user.permissions.every((permission) => permission.code === UserPermissions.VIEW_USERS)
  );
};
